import React from 'react';
import { useTranslation } from 'react-i18next';
import { TABLE_STATUS, tableStatusLabel } from '../../lib/constants';
import { cn } from '../../lib/utils';

export const StatusPill = ({ status, className }) => {
  const { t } = useTranslation();
  const s = TABLE_STATUS[status] || TABLE_STATUS.free;
  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border', className)}
      style={{ borderColor: `hsl(var(--${s.color}))`, color: `hsl(var(--${s.color}))` }}>
      <span className={cn('h-2 w-2 rounded-full', s.dot)} />
      {tableStatusLabel(t, status)}
    </span>
  );
};
